import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import './../node_modules/bulma/css/bulma.css';
import loadingscreen from '@/components/loadingscreen.vue'



import axios from 'axios'
Vue.prototype.$axios = axios

//Vue.prototype.$backendURL = "http://localhost:8000/api"
Vue.prototype.$backendURL = "https://wirewizard.cloud/api"
    //Vue.prototype.$backendURL = "http://wirewizard.quantumfrog.de/api"

Vue.config.productionTip = false

import HTTPRequestsMixin from './mixins/HTTPRequestsMixin'
Vue.mixin(HTTPRequestsMixin)

Vue.component("loadingscreen", loadingscreen)


Vue.prototype.$allowedUnauthenticatedRoutes = ['Login', 'register', 'impressum', 'feedback', 'Home']

router.beforeEach((to, from, next) => {
    router.app.$emit('pageclick', null)
    router.app.$emit('navigationChange', null)
    console.log("route to: " + to.name)
    if (Vue.prototype.$allowedUnauthenticatedRoutes.includes(to.name)) {
        next();
    } else {
        if (localStorage.bearertoken == "") {
            next("/login");
        }


        let checkLogin = new Promise((resolve, reject) => {
            if (localStorage.bearertoken == "") {
                reject("no token")
            }
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }
            axios.get(Vue.prototype.$backendURL + "/auth/user", { headers: headerData }).then(
                function(response) {
                    console.log("Vue.router.beforeEach - Ok: Got userdata from /user")

                    resolve(response)
                }
            ).catch(function(error) {
                console.log("Vue.router.beforeEach - Error: " + JSON.stringify(error))
                reject(error);
            });
        });

        checkLogin.then(function(response) {
            store.commit('setUsername', response.data.name)
            store.commit('setUser', response.data)

            if (response.data.is_admin) {
                store.commit('setUserRole', 2)

            } else {
                store.commit('setUserRole', 1)
            }
            next();


        }.bind(this)).catch(function(error) {
            store.commit('setUsername', null)
            store.commit('setUserRole', null)
            store.commit('setUser', null)


            router.push({ name: 'Login', params: { nextRoute: to.name } })

            //     next("/login");
        }.bind(this));
    }
})

new Vue({
    router,
    store,
    render: function(h) { return h(App) }
}).$mount('#app')